(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boeckmann-equipment-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.equistoreEquipmentGuideReady)return;
  window.equistoreEquipmentGuideReady=true;
  const prices=window.EquistoreConfigPrices,money=c=>prices.money(c);
  function refresh(root){
    root.querySelectorAll('.eq-option').forEach(field=>{
      const select=field.querySelector('select[data-option]'),status=field.querySelector('[data-eq-option-status]');
      if(!select||!status)return;
      const o=select.selectedOptions[0];if(!o)return;
      const value=o.dataset.label||o.value,price=prices.option(root,o,select).price;
      const none=/^(Utan |Ingen |Inga |Inget )/i.test(value);
      let label='Grundutförande · inget tillägg';
      if(select.dataset.includedBy)label='Ingår i '+select.dataset.includedBy;
      else if(o.dataset.unpriced==='true')label='Pris på förfrågan';
      else if(none)label='Ej valt · inget tillägg';
      else if(price>0)label='Valt tillval · +'+money(price);
      else if(price<0)label='Prisavdrag · '+money(price);
      else if(/standard|ingår/i.test(value))label='Ingår i grundutförandet';
      status.textContent=label;status.toggleAttribute('data-active',!none&&(price!==0||Boolean(select.dataset.includedBy)));
    });
  }
  function init(scope=document){scope.querySelectorAll('[data-equipment-guide]').forEach(root=>{
    if(root.dataset.equipmentReady)return;root.dataset.equipmentReady='true';
    root.querySelectorAll('.eq-option-thumb img').forEach(img=>{
      const source=img.getAttribute('src');if(!source)return;
      const url=new URL(source,document.baseURI);
      if(url.hostname!=='cdn.shopify.com'&&!url.pathname.startsWith('/cdn/shop/'))return;
      url.searchParams.set('width',img.closest('.eq-option-thumb--door')?'800':'320');
      img.decoding='async';img.fetchPriority='low';
      img.src=url.href;img.loading='eager';
    });
    root.addEventListener('change',()=>queueMicrotask(()=>refresh(root)));refresh(root);
  });}
  document.addEventListener('bock:configuration',event=>{const root=event.target.closest('[data-equipment-guide]');if(root)refresh(root);});
  let modal,trigger;
  function getModal(){
    if(modal)return modal;
    modal=document.createElement('dialog');modal.className='eq-photo-dialog';modal.setAttribute('aria-labelledby','EqPhotoHeading');
    modal.innerHTML='<header><h2 id="EqPhotoHeading"></h2><button type="button" aria-label="Stäng bild">Stäng ×</button></header><img alt=""><p></p>';
    document.body.append(modal);
    modal.querySelector('button').addEventListener('click',()=>modal.close());
    modal.addEventListener('click',event=>{if(event.target!==modal)return;const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();});
    modal.addEventListener('close',()=>{document.documentElement.style.overflow=modal.dataset.previousOverflow||'';trigger?.focus({preventScroll:true});});
    return modal;
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-equipment-guide] [data-eq-photo]');
    if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    if(typeof HTMLDialogElement==='undefined')return;
    event.preventDefault();trigger=link;const dialog=getModal();
    dialog.querySelector('h2').textContent=link.dataset.photoTitle;
    const img=dialog.querySelector('img');img.src=link.href;img.alt=link.querySelector('img').alt;
    dialog.querySelector('p').textContent=link.dataset.photoNote||'';
    dialog.dataset.previousOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';dialog.showModal();dialog.querySelector('button').focus();
  });
  init();document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pro-accessory-images"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pro-equipment')) {
  customElements.define('pro-equipment', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.init());
    }
    init() {
      if (!this.isConnected || this.initialized) return;
      this.picker = this.closest('variant-picker');
      this.section = this.closest('.shopify-section');
      this.native = this.picker?.querySelector('[data-option="Utrustning"]');
      this.select = this.native?.querySelector('custom-select');
      this.form = this.section?.querySelector('.js-product-form');
      if (!this.form) return;
      this.initialized = true;
      this.querySelectorAll('[data-pro-property]').forEach(input => input.setAttribute('form', this.form.getAttribute('id')));
      if (!this.select) { this.hidden = false; return; }
      this.onWidthChange = event => {
        if (!this.dataset.proWideTractor || !event.target.closest('[data-option="Arbetsbredd"]')) return;
        const width = this.picker.querySelector('[data-option="Arbetsbredd"] .js-option[aria-selected="true"]');
        if (width?.dataset.value !== '2,4 m') return;
        const tractorOption = [...this.select.querySelectorAll('.js-option')].find(option => option.dataset.value === this.dataset.proTractorEquipment);
        if (!tractorOption) return;
        event.stopImmediatePropagation();
        tractorOption.dataset.variantId = this.dataset.proWideTractor;
        this.select.selectOption(tractorOption);
      };
      this.picker.addEventListener('change', this.onWidthChange, true);
      this.onChoice = event => {
        if (!event.target.matches('[data-pro-name]')) return;
        event.stopPropagation();
        const previousChoices = [...this.querySelectorAll('[data-pro-name]')].map(input => ({input, checked: input === event.target ? !input.checked : input.checked}));
        if (this.hasAttribute('data-pro-combined') && event.target.checked) {
          const opposite = event.target.dataset.proKey === 'atv' ? 'adapter' : event.target.dataset.proKey === 'adapter' ? 'atv' : null;
          if (opposite) {
            const other = this.querySelector(`[data-pro-key="${opposite}"]`);
            if (other) other.checked = false;
          }
        }
        const names = [...this.querySelectorAll('[data-pro-name]:checked')].map(input => input.dataset.proName).sort();
        const target = [...this.select.querySelectorAll('.js-option')].find(option => {
          const values = option.dataset.value === 'Standard' ? [] : option.dataset.value.split(' + ').sort();
          return JSON.stringify(values) === JSON.stringify(names);
        });
        if (!target) { previousChoices.forEach(({input, checked}) => { input.checked = checked; }); return; }
        const key = event.target.dataset.proKey;
        const restoreFocus = event => {
          if (!this.section.contains(event.target)) return;
          this.section.querySelector(`[data-pro-key="${key}"]`)?.focus({preventScroll:true});
          document.removeEventListener('on:variant:change', restoreFocus);
        };
        document.addEventListener('on:variant:change', restoreFocus);
        setTimeout(() => document.removeEventListener('on:variant:change', restoreFocus), 15000);
        this.select.selectOption(target);
      };
      this.onPending = () => {
        this.setAttribute('aria-busy', 'true');
        this.picker.inert = true;
        this.buttons = [...this.section.querySelectorAll('button[name="add"]')].map(button => ({button, disabled:button.disabled}));
        this.buttons.forEach(({button}) => { button.disabled = true; });
        this.timer = setTimeout(() => {
          this.picker.inert = false;
          this.querySelector('.pro-equipment__error').hidden = false;
        }, 12000);
      };
      this.onSubmit = event => {
        if (this.getAttribute('aria-busy') === 'true') { event.preventDefault(); event.stopImmediatePropagation(); }
      };
      this.addEventListener('change', this.onChoice);
      this.picker.addEventListener('change', this.onPending);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.native.hidden = true;
      this.hidden = false;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.removeEventListener('change', this.onChoice);
      this.picker?.removeEventListener('change', this.onPending);
      this.picker?.removeEventListener('change', this.onWidthChange, true);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.buttons?.forEach(({button, disabled}) => { button.disabled = disabled; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
